import React from "react";

export interface GoogleIconProps {
  width?: number;
  height?: number;
  color?: string;
}

const GoogleIcon: React.FC<GoogleIconProps> = ({width = 24, height= 24}: GoogleIconProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 12.2728C24 11.4219 23.9221 10.6037 23.7774 9.81826H12.2449V14.4601H18.8349C18.551 15.9601 17.6883 17.231 16.3915 18.0819V21.0928H20.3488C22.6642 19.0037 24 15.9274 24 12.2728Z"
        fill="#4285F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.2449 24C15.551 24 18.3228 22.9255 20.3488 21.0928L16.3915 18.0819C15.295 18.8019 13.8924 19.2273 12.2449 19.2273C9.05567 19.2273 6.35623 17.1164 5.39333 14.28H1.30242V17.3891C3.31726 21.3109 7.45827 24 12.2449 24Z"
        fill="#34A853"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.39333 14.28C5.14843 13.56 5.00928 12.791 5.00928 12.0001C5.00928 11.2092 5.14843 10.4401 5.39332 9.72007V6.61097H1.30241C0.473099 8.23098 0 10.0637 0 12.0001C0 13.9364 0.473104 15.7691 1.30242 17.3891L5.39333 14.28Z"
        fill="#FBBC05"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.2449 4.77273C14.0427 4.77273 15.6568 5.37818 16.9258 6.56728L20.4379 3.12546C18.3173 1.18909 15.5455 0 12.2449 0C7.45827 0 3.31726 2.68915 1.30241 6.61097L5.39332 9.72007C6.35622 6.8837 9.05567 4.77273 12.2449 4.77273Z"
        fill="#EA4335"
      />
    </svg>
  );
};

export default GoogleIcon;
